import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Route, Routes } from 'react-router-dom';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Home from './pages/home/Home';
import Contact from './pages/ContactUs/ContactUs.jsx';
import Category from './pages/Category/index.jsx';
import SellWithUs from './pages/SellWithUs/index.jsx';
import HowToBid from './pages/HowToBid/index.jsx';
import Auction from './pages/Auction/index.jsx';
import AuctionDetail from './pages/AuctionDetail/AuctionDetail.jsx';
import Sellers from './pages/Sellers/index.jsx';
import SellersProfile from './pages/SellersProfile/index.jsx';


const routes = [
  { path: "/", element: <Home /> },
  { path: "/contact", element: <Contact /> },
  { path: "/Category", element: <Category /> },
  { path: "/SellWithUs", element: <SellWithUs /> },
  { path: "/HowToBid", element: <HowToBid /> },
  { path: "/Auction", element: <Auction /> },
  { path: "/auction/:id", element: <AuctionDetail /> },
  { path: "/Sellers", element: <Sellers /> },
  { path: "/SellersProfile", element: <SellersProfile /> },

];

function App() {
  return (
    <Routes>
      {routes.map((route, index) => (
        <Route key={index} path={route.path} element={route.element} />
      ))}
    </Routes>
  );
}

export default App;
